import { render } from "./RegionDropdown.vue?vue&type=template&id=19a4e031&scoped=true"
import script from "./RegionDropdown.vue?vue&type=script&lang=js"
export * from "./RegionDropdown.vue?vue&type=script&lang=js"

import "./RegionDropdown.vue?vue&type=style&index=0&id=19a4e031&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a4e031"]])

export default __exports__